import React, { Component } from 'react';

class EventBranchRow extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    var searchType = this.props.searchType;
    var entity = this.props.entity;
    var distance = 0;
    var distanceTxt = '';
    if(searchType === 'distance') {
      distance = entity.distance;
      if(distance < 1) {
        distanceTxt = Math.ceil(distance * 1000) + 'm';
      } else {
        distanceTxt = Math.ceil(distance * 10) / 10 + 'km';
      }
    }

    return (
      <li>
        <p className="btxt">{entity.branchName}</p>
        <p className="km">{distanceTxt}</p>
        <p className="radios">
          <a href={null}
            style={{width: "48px", padding: "0px 15px", lineHeight: "26px", borderRadius: "18px", backgroundColor: "#999999", color: "#fff", fontSize: "13px"}}
            className="loca-btn fr layer-pop-open"
            data-type="location"
            data-branch_id={this.props.branch_id}
            onClick={this.props.onClick}>위치보기</a>
          <label htmlFor={entity.id}>&nbsp;</label> 
        </p>
      </li>
    )
  }
}

export default EventBranchRow;